import  { useCallback, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import ImageViewer from "react-simple-image-viewer";

/**
 * Renders Component.
 * @return {StudentGallery} renders Component.
 */
export default function Gallery(props: any) {

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState<any>([]);

  useEffect(() => {
    let img = props.images.map((item: any) => item.org_img);
    setImages(img);
  }, [props]);
  const openImageViewer = useCallback((index: number) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <>
      <div className="cmmn">
        <Container className="container ">
          {/* <BackSecion name="Gallery" navigate_action="/home" /> */}

          <div className="row mt-4 m-auto justify-content-around">
            {props.images &&
              props.images.length > 0 &&
              props.images.map((item: any, index: number) => {
                return (
                  <div
                    className="col-5 col-sm-4 mb-2 d-flex flex-column align-items-center"
                    key={`album-${index}`}
                  >
                    <div className="mb-2">
                      <img
                        src={item.cover_img_url}
                        onClick={() => openImageViewer(index)}
                        width="156px"
                        height="156px"
                        key={index}
                        style={{ margin: "2px" }}
                        alt=""
                      />
                    </div>
                  </div>
                );
              })}
            {isViewerOpen && (
              <ImageViewer
                src={images}
                currentIndex={currentImage}
                onClose={closeImageViewer}
                disableScroll={false}
                // backgroundStyle={{'background':'transparent'}}
                closeOnClickOutside={true}
              />
            )}
          </div>
        </Container>
      </div>
    </>
  );
}
